<template>
    <div class="user_zl no-trans" v-loading="loading">
        <div class="page_name">个人资料</div>
        <div class="info_box">
            <div class="tops">
                <div class="title_flex">
                    <div class="bordes"></div>
                    <div class="texts">基本信息</div>
                </div>
                <div class="form_top">
                    <div class="form_flex">
                        <div class="form_title">头像：</div>
                        <div class="form_input" @click="handle_avatar">
                            <div class="imgs_box">
                                <div class="imgs">
                                    <img src="@/assets/img/user_info/user_zl/user_img.png" alt="" v-if="!user_info.image">
                                    <img :src="user_info.image" alt="" v-if="user_info.image">
                                </div>
                                <div class="text_bg">修改头像</div>
                            </div>
                        </div>
                        <div class="qyhhr" v-if="user_info.partner==2">
                            区域合伙人
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title">手机：</div>
                        <div class="form_input">
                            <div class="phone_felx">
                                <div class="phones_text">{{ user_info.mobile }}</div>
                                <div class="phones_btns" @click="handle_phone">修改</div>
                            </div>
                        </div>
                    </div>
                      <div class="form_flex">
                        <div class="form_title">昵称：</div>
                        <div class="form_input">
                            <div class="phone_felx">
                                <div class="phones_text">
                                    <el-input v-model="user_info.nickname" placeholder="请输入昵称" :disabled="nickname_disabled"></el-input>
                                </div>
                                <div class="phones_btns" @click="nickname_disabled=false" v-if="nickname_disabled">修改</div>
                                <div class="phones_btns" @click="handle_nickname" v-if="!nickname_disabled">保存</div>
                            </div>
                        </div>
                    </div>
                    <div class="borders"></div>
                </div>
            </div>
            <div class="boms">
                <div class="title_flex">
                    <div class="bordes"></div>
                    <div class="texts">会员信息</div>
                </div>
                <div class="form_bom">
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>选择身份</div>
                        <div class="form_input">
                            <div class="check_type">
                                <el-select v-model="type_ac" placeholder="请选择" disabled>
                                    <el-option
                                    v-for="(item,index) in type_list"
                                    :key="index"
                                    :label="item.title"
                                    :value="item.type">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div v-if="type_ac==1">
                        <huiyuan ref="huiyuan"></huiyuan>
                    </div>
                    <div v-if="type_ac==2">
                        <ls_box ref="ls_box"></ls_box>
                    </div>
                    <div v-if="type_ac==3">
                        <falvzhuanjia ref="falvzhuanjia"></falvzhuanjia>
                    </div>
                    <div v-if="type_ac==4">
                        <flzgcyz ref="flzgcyz"></flzgcyz>
                    </div>
                    <div v-if="type_ac==5">
                        <gongshang ref="gongshang"></gongshang>
                    </div>
                    <div v-if="type_ac==6">
                        <lvsuo ref="lvsuo"></lvsuo>
                    </div>
                </div>
            </div>
        </div>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>
        
        <phone ref="phone" :user_info="user_info" @get_user="get_user"></phone>
    </div>
</template>
<script>
import { mapState} from 'vuex'
import upload from '@/components/upload/upload.vue'
 
import huiyuan from '@/components/user_zl/huiyuan.vue'//会员
import ls_box from '@/components/user_zl/lvshi.vue'//律师
import falvzhuanjia from '@/components/user_zl/falvzhuanjia.vue'//法律专家
import flzgcyz from '@/components/user_zl/flzgcyz.vue'//法律资格从业者
import gongshang from '@/components/user_zl/gongshang.vue'//工商企业
import lvsuo from '@/components/user_zl/lvsuo.vue'//律所
import phone from '@/components/user_zl/phone.vue'//手机号绑定

export default {
    components: {
        ls_box,
        huiyuan,
        falvzhuanjia,
        flzgcyz,
        gongshang,
        lvsuo,
        phone,
        upload,

    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png']),
            nickname_disabled:true,
            loading: false,
            type_ac:1,
            user_info:{},
            // 身份:1普通用户,2律师-执业,3律师-非执业,4法律专家,5法律资格从业者,6工商企业,7律所
            type_list:[
                {
                    title:'普通会员',
                    type:1,
                },
                {
                    title:'律师',
                    type:2,
                },
                {
                    title:'法律专家',
                    type:3,
                },
                {
                    title:'法律资格从业者',
                    type:4,
                },
                {
                    title:'工商企业',
                    type:5,
                },
                {
                    title:'律所',
                    type:6,
                },

            ],
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_user()
    },
    methods: {
        get_user(){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('用户信息',res)
                if (res.code == 1) {
                    if(res.data.type==1){
                        this.type_ac=1
                    }
                    if(res.data.type==2||res.data.type==3){
                        this.type_ac=2
                    }
                    if(res.data.type==4){
                        this.type_ac=3
                    }
                    if(res.data.type==5){
                        this.type_ac=4
                    }
                    if(res.data.type==6){
                        this.type_ac=5
                    }
                    if(res.data.type==7){
                        this.type_ac=6
                    }
                   
                   this.user_info=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_phone(){
            this.$refs.phone.handle_open()
        },
        handle_avatar(){
            let datas={
               
            }
            this.$refs.uploads.uploadFile(datas)
        },
        upload_url(res_data,datas){
            console.log('res_data',res_data)
            this.$api("updateImage", {
                img:res_data.path,
			}, "get").then((res) => {
                this.loading = false
                console.log('提交用户信息',res)
                if (res.code == 1) {
                   this.get_user()
                } else {
                    alertErr(res.msg)
                }
            });
        },

        handle_nickname(){
            this.$confirm('昵称7天内只可修改1次，是否保存', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
             this.$api("updateNickname", {
                nickname:this.user_info.nickname
            }, "post").then((res) => {
                this.loading = false
                console.log('修改昵称',res)
                if (res.code == 1) {
                    alertSucc('昵称保存成功，请等待审核')
                    this.nickname_disabled=!this.nickname_disabled
                   this.get_user()

                } else {
                    alertErr(res.msg)
                }
            });
            }).catch(() => {
                  
            });
        },


    },

}
</script>
<style scoped lang="less">
.user_zl {  
    .page_name{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        line-height: 56px;  
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;

    }
    .info_box{
        width: 1196px;
        min-height: 1013px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 18px;
        .tops{
            .title_flex{
                display: flex;
                align-items: center;
                padding-top: 30px;
                .bordes{
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .texts{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #666666;
                    padding-left: 28px;
                }
            }
            .form_top{
                padding-top: 30px;
                .form_flex{
                    display: flex;
                    margin-bottom: 30px;
                    .form_title{
                        width: 200px;
                        line-height: 40px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        text-align: right;
                    }
                    .form_input{
                        .imgs_box{
                            position: relative;
                            width: 88px;
                            height: 88px;
                            margin-left: 10px;
                        
                            .imgs{
                                width: 88px;
                                height: 88px;
                                border-radius: 50%;
                                img{
                                    width: 88px;
                                    height: 88px;
                                    border-radius: 50%;
                                }
                            }
                            .text_bg{
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 88px;
                                height: 88px;
                                background: #000000;
                                border-radius: 50%;
                                opacity: 0.55;
                                cursor: pointer;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                line-height: 88px;
                                text-align: center;
                            }
                        }
                        .phone_felx{
                            margin-left: 26px;
                            display: flex;
                            align-items: center;
                            line-height: 40px;
                            .phones_text{
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                            .phones_btns{
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                margin-left: 40px;
                                cursor: pointer;
                            }
                        }
                    }
                    .qyhhr{
                        line-height: 88px;
                        margin-left: 30px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }
                }
                .borders{
                    width: 1092px;
                    height: 0px;
                    background: #CCCCCC;
                    border: 1px solid #DBDBDB;
                    margin-left: 32px;
                }
            }
        }
        .boms{
            .title_flex{
                display: flex;
                align-items: center;
                padding-top: 30px;
                .bordes{
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .texts{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #666666;
                    padding-left: 28px;
                }
            }
            .form_bom{
                .form_flex{
                    display: flex;
                    margin-bottom: 30px;
                    padding-top: 30px;
                    span{
                        color: #FD4C5C;
                    }
                    .form_title{
                        width: 200px;
                        line-height: 40px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        text-align: right;
                        padding-right: 24px;
                    } 
                    .form_input{
                        .check_type{
                            width: 400px;
                            height: 40px;
                            /deep/.el-select{
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_zl.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_zl.no-trans .page_name {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        line-height: 1.6;
        font-size: 16px;
    }
    .user_zl.no-trans .info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .user_zl.no-trans .info_box .tops .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .user_zl.no-trans .info_box .tops .title_flex .bordes {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
    }
    .user_zl.no-trans .info_box .tops .title_flex .texts {
        font-size: 18px;
        padding-left: 16px;
    }
    .user_zl.no-trans .info_box .tops .form_top {
        padding-top: 16px;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_title {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        line-height: 1.6;
        font-size: 14px;
        text-align: left;
        padding: 0;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_input .imgs_box {
        width: 88px;
        min-height: 0;
        height: auto;
        margin-left: 10px;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_input .imgs_box .imgs {
        width: 88px;
        min-height: 0;
        height: auto;
        border-radius: 50%;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_input .imgs_box .imgs img {
        width: 88px;
        min-height: 0;
        height: auto;
        border-radius: 50%;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_input .imgs_box .text_bg {
        width: 88px;
        min-height: 0;
        height: auto;
        border-radius: 50%;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_input .phone_felx {
        margin-left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        line-height: 40px;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_input .phone_felx .phones_text {
        font-size: 14px;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .form_input .phone_felx .phones_btns {
        font-size: 14px;
        margin-left: 16px;
    }
    .user_zl.no-trans .info_box .tops .form_top .form_flex .qyhhr {
        line-height: 1.6;
        margin-left: 16px;
        font-size: 14px;
    }
    .user_zl.no-trans .info_box .tops .form_top .borders {
        max-width: 100%;
        min-width: 0;
        height: 0px;
        width: 100%;
        margin-left: 16px;
    }
    .user_zl.no-trans .info_box .boms .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .user_zl.no-trans .info_box .boms .title_flex .bordes {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
    }
    .user_zl.no-trans .info_box .boms .title_flex .texts {
        font-size: 18px;
        padding-left: 16px;
    }
    .user_zl.no-trans .info_box .boms .form_bom .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
        padding-top: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .user_zl.no-trans .info_box .boms .form_bom .form_flex .form_title {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        line-height: 1.6;
        font-size: 14px;
        padding-right: 16px;
        text-align: left;
        padding: 0;
    }
    .user_zl.no-trans .info_box .boms .form_bom .form_flex .form_input .check_type {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
}
</style>
